export default __webpack_public_path__ + "static/media/applewallet.2f221239.svg";